import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function User({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M9.99998 7.92672C11.8 7.92672 13.2592 6.4675 13.2592 4.66746C13.2592 2.86742 11.8 1.4082 9.99998 1.4082C8.19994 1.4082 6.74072 2.86742 6.74072 4.66746C6.74072 6.4675 8.19994 7.92672 9.99998 7.92672Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6439 17.7224C16.6632 17.4013 17.1989 16.2753 16.7663 15.2987C15.6167 12.702 13.0223 10.8887 10.0001 10.8887C6.97787 10.8887 4.3835 12.702 3.23387 15.2987C2.80128 16.2765 3.33698 17.4013 4.35624 17.7224C5.80809 18.1799 7.72928 18.5924 10.0001 18.5924C12.2709 18.5924 14.1921 18.1799 15.6439 17.7224Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
